import { Dexie } from 'dexie';
export interface Category {
  category_id: string;
  category_name: string;
}

export interface Movies {
  name: string;
  stream_id: number;
  category_id: string;
  stream_icon:string;
  container_extension:string;
  tmdb_id:number;
  rating:string;
  stream_type:string;
  // Include other movie fields if needed
}

export class MoviedbService extends Dexie{
  categories: Dexie.Table<Category, string>;
  movies: Dexie.Table<Movies, number>;
   constructor() {
    super('MovieDB');
    this.version(1).stores({
      categories: 'category_id',
      movies: '++id, stream_id, category_id'
    });

    this.categories = this.table('categories');
    this.movies = this.table('movies');
  }

}
export const Moviesdb = new MoviedbService();